import Home from '@/views/home/index.vue'
import Login from '@/views/login/index.vue'
import My from '@/views/My/index.vue'
import safeguard from '@/views/safeguard/index.vue'
import Authentication from '@/views/authentication.vue'

// 通用路由表
const constantRoutes = [
  {
    path: '/login',
    name: 'login',
    meta: { routeName: '登录页' },
    component: Login
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    meta: { bread: true, resetPath: 'homePath', routeName: '首页' },
    component: Home
  },
  {
    path: '/authentication',
    name: 'authentication',
    meta: { routeName: '登录认证' },
    component: Authentication
  },

  {
    path: '/my',
    name: 'my',
    redirect: '/my/loan',
    component: My,
    children: [
      {
        path: 'loan',
        name: 'loan',
        meta: { routeName: '我的贷款页' },
        component: () => import('@/views/My/loan')
      },
      {
        path: 'info',
        name: 'info',
        meta: { routeName: '企业信息页' },
        component: () => import('@/views/My/info')
      },
      {
        path: 'message',
        name: 'message',
        meta: { routeName: '我的消息页' },
        component: () => import('@/views/My/message')
      },
      {
        path: 'loan-detail/:id',
        name: 'loan-detail',
        meta: { bread: true, resetPath: 'loanDetailPath', routeName: '我的贷款详情页' },
        component: () => import('@/views/My/loan/loanDetail')
      },
      {
        path: '*',
        redirect: 'loan'
      }
    ]
  },
  {
    path: '/product',
    name: 'product',
    meta: { bread: true, resetPath: 'productPath', routeName: '产品列表页' },
    component: () => import('@/views/product/index.vue')
  },
  {
    path: '/product-detail',
    name: 'product-detail',
    meta: { bread: true, routeName: '产品详情页' },
    component: () => import('@/views/productDetail')
  },
  {
    path: '/financing-apply',
    name: 'financing-apply',
    meta: { bread: true, routeName: '发起融资页' },
    component: () => import('@/views/financingApply')
  },
  {
    path: '/order-confirm',
    name: 'order-confirm',
    meta: { bread: true, routeName: '订单确认页' },
    component: () => import('@/views/orderConfirm')
  },
  {
    path: '/submit-success',
    name: 'submit-success',
    meta: { bread: true, routeName: '提交订单成功页' },
    component: () => import('@/views/submitSuccess')
  },
  {
    path: '/match-product',
    name: 'match-product',
    meta: { bread: true, routeName: '匹配产品页' },
    component: () => import('@/views/matchProduct')
  },
  {
    path: '/intro',
    name: 'intro',
    meta: { bread: true, routeName: '平台介绍页' },
    component: () => import('@/views/platformIntro')
  },
  {
    path: '/road',
    name: 'road',
    meta: { routeName: '一带一路页' },
    component: () => import('@/views/oneRoad')
  },
  {
    path: '/article/:id',
    name: 'article',
    meta: { routeName: '辖内金融机构详情页' },
    component: () => import('@/views/article')
  },
  {
    path: '/table/:id',
    name: 'table',
    meta: { routeName: '辖内金融产品服务详情页' },
    component: () => import('@/views/tableArticle')
  },
  {
    path: '/knowledge',
    name: 'knowledge',
    meta: { routeName: '国家知识产权局' },
    component: () => import('@/views/knowledge')
  },
  {
    path: '/noAuth',
    name: 'noAuth',
    meta: { routeName: '个人账号认证等级不足提示页' },
    component: () => import('@/views/noAuth')
  },
  {
    path: '/safeguard',
    name: 'safeguard',
    meta: { routeName: '系统维护' },
    component: safeguard
  }
]

export default constantRoutes
